import React from "react";
import { Router } from "@reach/router";
import Redirect from "components/redirect";
import Add from "./add";
import Edit from "./edit";
import routes from "utils/absoluteRoutes";

const OperatinalManagementRoutes = () => {
  return (
    <Router className="router">
      <Redirect default to={routes.redirects.notFound} />
      <Add path="add/*" />
      <Edit path=":credentialId/*" />
    </Router>
  );
};
export default OperatinalManagementRoutes;
